<template>
    <div id="qrcode"></div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
    data(){
        return{
            
        }
    },
    props:['codeUrl'],
    mounted() {
    this.generateQrcode();
    },
    methods: {
        /* eslint-disable */
        generateQrcode() {
            new QRCode('qrcode', {
                width: 120,
                height: 120,
                text: this.codeUrl, // 二维码地址
                colorDark: '#000',
                colorLight: '#fff'
            });
        }
    }
}
</script>